import { v4 as uuidv4 } from 'uuid'
import { createAction, ActionsUnion } from 'utils/redux'
import { PartialBy } from 'utils/types'
import { Growl, Dialog, PendingWorkflow } from './notificationTypes'
import { getCurrentWindowId } from 'utils'

export enum NotificationActionTypes {
  DIALOG_CREATE = 'DIALOG_CREATE',
  DIALOG_DISMISS = 'DIALOG_DISMISS',
  GROWL_CREATE = 'GROWL_CREATE',
  GROWL_DISMISS = 'GROWL_DISMISS',
  CREATE_PENDING_WORKFLOW = 'CREATE_PENDING_WORKFLOW',
  REMOVE_PENDING_WORKFLOW = 'REMOVE_PENDING_WORKFLOW'
}

export type ShowGrowlArgs = PartialBy<Growl, 'id' | 'targetWindowId'>
export type ShowDialogArgs = PartialBy<Dialog, 'id' | 'targetWindowId'>

export const NotificationActions = {
  showGrowl: (growlArgs: ShowGrowlArgs) =>
    createAction(NotificationActionTypes.GROWL_CREATE, {
      ...growlArgs,
      id: growlArgs.id || uuidv4(),
      targetWindowId: growlArgs.targetWindowId || getCurrentWindowId()
    }),
  dismissGrowl: (id: string) => createAction(NotificationActionTypes.GROWL_DISMISS, { id }),
  showDialog: (dialogArgs: ShowDialogArgs) =>
    createAction(NotificationActionTypes.DIALOG_CREATE, {
      ...dialogArgs,
      id: dialogArgs.id || uuidv4(),
      targetWindowId: dialogArgs.targetWindowId || getCurrentWindowId()
    }),
  dismissDialog: (id: string) => createAction(NotificationActionTypes.DIALOG_DISMISS, { id }),

  createPendingWorkflow: (correlationId: string, pendingWorkflow: PendingWorkflow) =>
    createAction(NotificationActionTypes.CREATE_PENDING_WORKFLOW, { correlationId, ...pendingWorkflow }),

  removePendingWorkflow: (correlationId: string) => createAction(NotificationActionTypes.REMOVE_PENDING_WORKFLOW, { correlationId })
}

export type NotificationActions = ActionsUnion<typeof NotificationActions>
